var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-6"},[(_vm.params.value.length > 0)?_c('span',{staticClass:"copon",staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.params.value)+" ")]):_vm._e()])])])}
var staticRenderFns = []

export { render, staticRenderFns }